


$(document).ready(function () {
    let filterModel = {
        PetTypeId: 0,
        LifeStage: null,
        Topic: null,
        BlogLandingId: 0,
        CurrentPage: 0,
        PageSize: 0,
        OrderByPublishDate: false
    };

    let fromPopState = false;
    let blockPopstateEvent = true;
    let browserSupportsHistoryApi = window.history && 'pushState' in window.history;

    if (browserSupportsHistoryApi) {
        // prevent Chrome from calling onpopstate on initial load
        $(window).on('load', function () {
            // The timeout ensures that popstate-events will be unblocked right
            // after the load event occured, but not in the same event-loop cycle.
            setTimeout(function () { blockPopstateEvent = false; }, 0);
        });

        $(window).on('popstate', function () {
            if (blockPopstateEvent && document.readyState === "complete") {
                return;
            }
            fromPopState = true;
            performSearchFromUrl();
        });
    }


    function performSearchFromUrl() {
        filterModel.CurrentPage = 1;
        filterModel.PetTypeId = null;
        filterModel.Topic = null;
        filterModel.LifeStage = null;
        if (window.location.search.length > 1) {
            for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
                nKeyId < aCouples.length;
                nKeyId++) {
                aItKey = aCouples[nKeyId].split("=");
                if (aItKey.length <= 1)
                    continue;
                var key = decodeURIComponent(aItKey[0]).toLowerCase();
                var val = decodeURIComponent(aItKey[1]);

                if (key === "pettype") {
                    filterModel.PetTypeId = val;
                } else if (key === "topic") {
                    filterModel.Topic = val;
                } else if (key === "lifestage") {
                    filterModel.LifeStage = val;
                } else if (key === "page") {
                    filterModel.CurrentPage = val;
                }
            }
        }
        getBlogArticles();
    }

    function getBlogArticles() {
        $.ajax({
            url: "/umbraco/surface/BHBlogArticleSurface/GetFilterResult",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                $(".js-blog-articles-filter-results").html(data);
                pushHistory();
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    function pushHistory() {
        if (browserSupportsHistoryApi && !fromPopState) {
            var nextUrl = new URL(location.protocol + '//' + location.host + location.pathname)

            if (filterModel.PetTypeId && filterModel.PetTypeId != 0) {
                nextUrl.searchParams.append('pettype', filterModel.PetTypeId);
            }

            if (filterModel.Topic) {
                nextUrl.searchParams.append('topic', filterModel.Topic);
            }

            if (filterModel.LifeStage) {
                nextUrl.searchParams.append('lifestage', filterModel.LifeStage);
            }

            if (filterModel.CurrentPage) {
                nextUrl.searchParams.append('page', filterModel.CurrentPage);
            }

            window.history.pushState(null, null, nextUrl);
        }
        fromPopState = false;
    };

    $(document).on("click", ".js-blogarticle-filter-submit", function () {

        onSubmit();
        $(".js-close-toggle").click();

    });

    function onSubmit(currentPage = 0) {
        filterModel = {
            PetTypeId: 0,
            LifeStage: null,
            Topic: null,
            BlogLandingId: 0,
            CurrentPage: currentPage,
            PageSize: 0,
            OrderByPublishDate: false
        };


        $('.filters-list__button').each(function () {
            if ($(this).hasClass('is-active')) {
                if ($(this).hasClass('js-blog-article-filter-topic')) {
                    filterModel.Topic = $(this).attr("value").toLowerCase();
                } else if ($(this).hasClass('js-blog-article-filter-lifestage')) {
                    filterModel.LifeStage = $(this).attr("value").toLowerCase();
                } else if ($(this).hasClass('js-blog-article-filter-pettype')) {
                    filterModel.PetTypeId = parseInt($(this).attr('id').replace('pet-type-', ''));
                }
            }
        });

        filterModel.BlogLandingId = $(".js-blog-landing").attr('id');
        filterModel.PageSize = $(".js-blog-landing-page-size").val();
        filterModel.OrderByPublishDate = $(".js-blog-landing-order-by-publish-date").val();

        getBlogArticles();
        $('html, body').animate({
            scrollTop: $(".js-blog-articles-filter-results").offset().top - 100
        }, 1);
    }

    $(document).on("click", ".js-blog-article-filter-lifestage", function (e) {
        e.preventDefault();
        onFilterClick($(this), ".js-blog-article-filter-lifestage");
    });

    $(document).on("click", ".js-blog-article-filter-pettype", function (e) {
        e.preventDefault();
        onFilterClick($(this), ".js-blog-article-filter-pettype");
    });

    $(document).on("click", ".js-blog-article-filter-topic", function (e) {
        e.preventDefault();
        onFilterClick($(this), ".js-blog-article-filter-topic");
    });

    function onFilterClick(thisObj, className) {
        thisObj.toggleClass("is-active");
        $(className).not(thisObj).removeClass("is-active");
        thisObj.blur();
    }

    // Pagination
    $(document).on("click", ".js-next-pagination-button", function (e) {
        e.preventDefault();
        if ($(this).hasClass("pagination__button--disabled")) return;

        const currentPage = parseInt($(".js-pagination").data("currentpage"));
        onSubmit(currentPage + 1);
    });

    $(document).on("click", ".js-back-pagination-button", function (e) {
        e.preventDefault();
        if ($(this).hasClass("pagination__button--disabled")) return;

        const currentPage = parseInt($(".js-pagination").data("currentpage"));
        onSubmit(currentPage - 1);
    });

    $(document).on("change", "#js-blog-article-pagination-input", function (e) {
        const pageCount = parseInt($(".js-pagination").data("pagecount"));
        const currentPage = parseInt($(this).val());
        if (currentPage > 0 && currentPage <= pageCount) {
            onSubmit(parseInt(currentPage));
        }
    }
    );
});
